import clsx from 'clsx';
import { Formik } from 'formik';
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { useQueryClient } from 'react-query';

import AutoSave from '@components/AutoSave';
import AutocompleteField from '@components/Form/AutocompleteField';
import useEntitiesTop from '@hooks/useEntitiesTop';
import useFollowUpdate from '@hooks/useFollowUpdate';
import { autocompleteEntities } from '@utils/backend-api/entities';
import { FollowAction, FollowType } from '@utils/backend-api/follow';

const INITIAL_FORM_STATE = { entity: { label: '', value: '' } };

interface AddTopicFormProps {
  className?: string;
  identityId: number | string;
}

const AddTopicForm = ({ className, identityId }: AddTopicFormProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateFollow } = useFollowUpdate();
  const { data: topEntityOptions, isLoading: isLoadingTopEntityOptions } = useEntitiesTop();
  const topEntityOptionsNotFollowing = topEntityOptions?.filter(
    (topEntity) => !topEntity?.following
  );

  const handleSubmit = async (values, { resetForm }) => {
    if (!values.entity?.value) return;

    await updateFollow({
      followType: FollowType.Entity,
      followeeId: values.entity?.value,
      followAction: FollowAction.Follow,
      identityId: identityId,
      queryClient,
    });

    resetForm();
  };
  return (
    <Formik onSubmit={handleSubmit} initialValues={INITIAL_FORM_STATE}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          <div className="flexbox">
            <Col className={clsx('select-form-container', className)}>
              {!isLoadingTopEntityOptions && (
                <AutocompleteField
                  name="entity"
                  className="mb-16 mt-0"
                  isCreatable={false}
                  fetchMethod={(value) =>
                    autocompleteEntities({
                      fragment: value,
                    })
                  }
                  options={topEntityOptionsNotFollowing}
                  placeholder="Type to search topics…"
                />
              )}
            </Col>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddTopicForm;
